import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta08ForaAlcanceEnum {
  BRINCA_COM_OUTRA_CRIANCA = 'BRINCA_COM_OUTRA_CRIANCA',
  FALA_COM_OUTRA_CRIANCA = 'FALA_COM_OUTRA_CRIANCA',
  BALBUCIA_FAZ_BARULHO = 'BALBUCIA_FAZ_BARULHO',
  OLHA_PRA_OUTRA_CRIANCA = 'OLHA_PRA_OUTRA_CRIANCA',
  SORRI_PRA_OUTRA_CRIANCA = 'SORRI_PRA_OUTRA_CRIANCA',
  FICA_TIMIDO = 'FICA_TIMIDO',
  FICA_ANIMADO = 'FICA_ANIMADO',
}

export interface ConsultaSeguimentoPergunta08Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_08_HEADER?: SimNaoEnum
  PERGUNTA_08_SE_INTERESSA_POR?: SimNaoEnum
  PERGUNTA_08_RESPONDE_PERGUNTAS?: SimNaoEnum
  PERGUNTA_08_FORA_ALCANCE?: Record<ConsultaSeguimentoPergunta08ForaAlcanceEnum, SimNaoEnum | undefined>
  PERGUNTA_08_RESPONDE_CRIANCAS?: SimNaoEnum
}
